<template>
  <div class="seviceErr">
    <im-top></im-top>
    <!-- <img v-if="errType==='costomerErr'" class="errImg" :src="imgUrl+'im_sorry.png'" alt="无客服"> -->
    <img  class="errImg" :src="imgUrl+'im_err.png'" alt="服务器忙">
    <div class="text">您使用浏览器版本太低，请更换浏览器后再访问</div>
  </div>
</template>
<script>
import imTop from './IMTop.vue'
export default {
  components:{
    imTop
  },
  data () {
    return {
      imgUrl: '/pc/static/assets/',
      msgErr: '服务器繁忙，请稍后再试',
      msgService:'暂无服务的客服，请稍后再试',
      errType:""
    }
  },
  mounted () {
    //this.errType = this.$route.query.errType;
    //this.randerPage();
  },
  methods: {
    randerPage () {
      
    },
  }
}
</script>

<style scoped>
.seviceErr{
    /*height: 300px;
    width: 200px;
    background: #595959;*/
}
.errImg {
  display: block;
  width: 134px;
  margin:130px auto 25px auto;  
  /*margin:-310px 0 0 -320px;*/
}
.text {
  text-align: center;
  color: #acb2b6;
}
</style>




// WEBPACK FOOTER //
// src/components/im/beatis.vue?55ae806d